"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var keccak_1 = __importDefault(require("keccak"));

var rlp_1 = require("rlp");

var secp256k1_1 = require("secp256k1");

exports.publicKeyCreate = secp256k1_1.publicKeyCreate;

var utils_1 = require("../utils");

var constant_1 = require("./constant");

function hash(buffer) {
  return keccak_1.default('keccak256').update(buffer).digest();
}
/**
 * calculate an account address from a public key
 * @param publicKey
 */


function addressFromPublicKey(publicKey) {
  var hashed = hash(publicKey);
  var address = hashed.slice(0, 20);
  var magicAddressPrefix = Buffer.from([constant_1.PREFIX_ADDRESS_ACCOUNT]);
  return Buffer.concat([Buffer.from(magicAddressPrefix), Buffer.from(address)]);
}

exports.addressFromPublicKey = addressFromPublicKey;
/**
 * create a Transfer Transaction signature
 * @param tx
 * @param privateKey
 */

function signTransferTransaction(tx, privateKey) {
  var orderedTx = [constant_1.PREFIX_TRANSACTION_TRANSFER, tx.chainId, tx.feeAssetId, tx.feeCycle, tx.nonce, tx.timeout];
  orderedTx = orderedTx.concat([tx.carryingAmount, tx.carryingAssetId, tx.receiver]);
  var encoded = rlp_1.encode(orderedTx);
  var txHash = hash(encoded);

  var _secp256k1_1$sign = secp256k1_1.sign(txHash, privateKey),
      signature = _secp256k1_1$sign.signature;

  return Object.assign(Object.assign({}, tx), {
    pubkey: utils_1.toHex(secp256k1_1.publicKeyCreate(privateKey)),
    signature: utils_1.toHex(signature),
    txHash: utils_1.toHex(txHash)
  });
}

exports.signTransferTransaction = signTransferTransaction;